import { Component, inject, Input, OnInit } from '@angular/core';
import { DataTableBuilderComponent } from '@/components/data-table-builder/data-table-builder.component';
import { CompanyRepository } from '@/store/company-state/company-state.repository';
import { getCompanyMembersDataTbleObject } from './utils/company-members-data-table-object';
import { CompanyUser } from '@/types';

@Component({
  selector: 'sm-company-members',
  imports: [DataTableBuilderComponent],
  templateUrl: './company-members.component.html',
  styleUrl: './company-members.component.scss',
})
export class CompanyMembersComponent implements OnInit {
  companyRepository = inject(CompanyRepository);
  @Input() usersSociete!: CompanyUser[] | undefined;

  dataTableObject = getCompanyMembersDataTbleObject();

  data: any[] = [];
  ngOnInit() {
    if (this.usersSociete) {
      this.data = this.usersSociete;
    }
  }
}
